import clsx from 'clsx'
import { useState } from 'react'
import { WarningCircle } from 'phosphor-react'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../../../components/Button'
import { DialogModal } from '../../../../components/DialogModal'
import { EditForm } from './EditForm'
import { ReactComponent as EditSvg } from '../../../../assets/svgs/edit.svg'
import { ReactComponent as TrashSvg } from '../../../../assets/svgs/secondary-trash.svg'
import { ReactComponent as AddProjectSvg } from '../../../../assets/svgs/add-project.svg'

import { useMediaQuery } from '../../../../hooks/useMediaQuery'
import { Medias } from '../../../../enumns/medias'

type TableRowActionsProps = {
  hasBecomeProject: boolean
  cannotRemove?: boolean
  onRemove?: () => void
  isLoadingRemove?: boolean
  id: number
}

export const TableRowActions = ({
  hasBecomeProject,
  cannotRemove = false,
  onRemove,
  isLoadingRemove,
  id,
}: TableRowActionsProps) => {
  const [isModalAlertOpen, setIsModalAlertOpen] = useState(false)
  const [openEditRequestModal, setOpenEditRequestModal] =
    useState<boolean>(false)
  const navigate = useNavigate()

  const isMinimumWidthOfATablet = useMediaQuery(`(min-width: ${Medias.MD}px)`)

  const handleConfirmRemoval = () => {
    if (onRemove) {
      onRemove()
      setIsModalAlertOpen(false)
    }
  }

  const handleTransformToProject = () => {
    navigate('/painel/projects', {
      state: {
        requestId: id
      }
    })
  }

  return (
    <>
      <div className="flex items-center gap-4">
        <button onClick={() => setOpenEditRequestModal(true)}>
          <EditSvg className="stroke-grey-700" />
        </button>
        <button
          className={clsx({
            'disabled:opacity-50': cannotRemove,
          })}
          onClick={() => setIsModalAlertOpen(true)}
          disabled={cannotRemove}
        >
          <TrashSvg />
        </button>
        <button
          className={clsx({ 'opacity-50': hasBecomeProject })}
          disabled={hasBecomeProject}
          onClick={handleTransformToProject}
        >
          <AddProjectSvg />
        </button>
      </div>

      <DialogModal
        isOpen={isModalAlertOpen}
        onClose={
          isMinimumWidthOfATablet ? () => setIsModalAlertOpen(false) : undefined
        }
      >
        <div className="px-8 pb-6">
          <WarningCircle
            size={72}
            className="mx-auto mb-10 text-primary-light"
          />
          <p className="text-center mb-14 text-grey-900">
            Você está prestes a excluir uma request. Deseja continuar?
          </p>

          <div className="flex items-center gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => setIsModalAlertOpen(false)}
              fullWidth
            >
              Cancelar
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={handleConfirmRemoval}
              fullWidth
              isLoading={isLoadingRemove}
            >
              Continuar
            </Button>
          </div>
        </div>
      </DialogModal>

      {/* Modal Edit Request */}
      <DialogModal
        isOpen={openEditRequestModal}
        onClose={() => setOpenEditRequestModal(false)}
        title="Editar request"
      >
        <EditForm onClose={() => setOpenEditRequestModal(false)} id={id} />
      </DialogModal>
    </>
  )
}
